import { DropdownItemOption } from '../../../../interfaces/notebook';
import {
  VIEW_TASK_LABEL,
  EDIT_TASK_TITLE_LABEL,
  MARK_AS_COMPLETED,
  COPY_TASK_LINK_LABEL,
  ADD_SECTION_TO_LEFT_LABEL,
  ADD_SECTION_TO_RIGHT_LABEL,
  DELETE_SECTION_LABEL,
  RENAME_SECTION_LABEL,
} from '../../../../languages/en/notebook';
import {
  ARCHIVE as ARCHIVE_LABEL,
  ITEM,
} from '../../../../languages/en/singleWords';
import { capitalizeFirstLetter } from '../../../../Utils/text';
import { CustomButtonColorConfig } from '../../../../atomic/atoms/IconButton_V2/interface';
import ThemeV2 from '../../../../theme';

export enum BoardTaskDropdownOperations {
  EDIT_TASK_TITLE = 'editTitle',
  ARCHIVE = 'archive',
  COMPLETE = 'complete',
  COPY_LINK = 'copyLink',
  VIEW_TASK = 'viewTask',
}

export const taskDropdownItems: DropdownItemOption[] = [
  {
    id: BoardTaskDropdownOperations.EDIT_TASK_TITLE,
    value: EDIT_TASK_TITLE_LABEL,
    deleteItem: false,
    isSelected: false,
    prefixIcon: 'edit',
  },
  {
    id: BoardTaskDropdownOperations.VIEW_TASK,
    value: VIEW_TASK_LABEL,
    deleteItem: false,
    isSelected: false,
    prefixIcon: 'info-filled',
  },
  {
    id: BoardTaskDropdownOperations.COPY_LINK,
    value: COPY_TASK_LINK_LABEL,
    deleteItem: false,
    isSelected: false,
    prefixIcon: 'Link',
  },
  {
    id: BoardTaskDropdownOperations.COMPLETE,
    value: `${MARK_AS_COMPLETED}`,
    deleteItem: false,
    isSelected: false,
    prefixIcon: 'checkbox-circle-checked',
  },
  {
    id: BoardTaskDropdownOperations.ARCHIVE,
    value: `${capitalizeFirstLetter(ARCHIVE_LABEL)} ${ITEM}`,
    deleteItem: true,
    isSelected: false,
    prefixIcon: 'archive',
  },
];

export enum BoardSectionDropdownOperations {
  RENAME_SECTION = 'renameSection',
  ADD_SECTION_TO_RIGHT = 'addSectionToRight',
  ADD_SECTION_TO_LEFT = 'addSectionToLeft',
  DELETE_SECTION = 'DELETE_SECTION',
}

export const sectionDropdownItems: DropdownItemOption[] = [
  {
    id: BoardSectionDropdownOperations.RENAME_SECTION,
    value: `${RENAME_SECTION_LABEL}`,
    deleteItem: false,
    isSelected: false,
    prefixIcon: 'edit',
  },
  {
    id: BoardSectionDropdownOperations.ADD_SECTION_TO_RIGHT,
    value: `${ADD_SECTION_TO_RIGHT_LABEL}`,
    deleteItem: false,
    isSelected: false,
    prefixIcon: 'arrow-right',
  },
  {
    id: BoardSectionDropdownOperations.ADD_SECTION_TO_LEFT,
    value: `${ADD_SECTION_TO_LEFT_LABEL}`,
    deleteItem: false,
    isSelected: false,
    prefixIcon: 'arrow-left',
  },
  {
    id: BoardSectionDropdownOperations.DELETE_SECTION,
    value: `${DELETE_SECTION_LABEL}`,
    deleteItem: true,
    isSelected: false,
    prefixIcon: 'delete',
  },
];

export const completedSectionFilterOptions: DropdownItemOption[] = [
  {
    id: '7',
    value: 'Last 7 days',
    deleteItem: false,
    isSelected: false,
    prefixIcon: '',
  },
  {
    id: '30',
    value: 'Last 30 days',
    deleteItem: false,
    isSelected: false,
    prefixIcon: '',
  },
  {
    id: '180',
    value: 'Last 6 months',
    deleteItem: false,
    isSelected: false,
    prefixIcon: '',
  },
  {
    id: '0',
    value: 'All time',
    deleteItem: false,
    isSelected: false,
    prefixIcon: '',
  },
];

export const defaultColorConfig: CustomButtonColorConfig = {
  background: ThemeV2.palette.gray3,
  textColor: ThemeV2.palette.gray3,
  borderColor: ThemeV2.palette.gray8,
  hover: {
    background: ThemeV2.palette.gray4,
    textColor: ThemeV2.palette.gray8,
    borderColor: ThemeV2.palette.gray3,
  },
  active: {
    background: ThemeV2.palette.gray4,
    textColor: ThemeV2.palette.gray8,
    borderColor: ThemeV2.palette.gray3,
  },
};

export const completedSectionColorConfig: CustomButtonColorConfig = {
  ...defaultColorConfig,
  background: ThemeV2.palette.polarGreen2,
  textColor: ThemeV2.palette.polarGreen2,
};
